import { Heart, Droplet, HandHeart, Cross, Sparkles, Stethoscope } from "lucide-react";

const ITEMS = [
  { icon: Heart, label: "Solidarité" },
  { icon: Droplet, label: "Soins hebdomadaires" },
  { icon: HandHeart, label: "Accompagnement" },
  { icon: Cross, label: "Recherche" },
  { icon: Sparkles, label: "Espoir" },
  { icon: Stethoscope, label: "Maladie de Waldmann" },
];

const Row = ({ hidden = false }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item, i) => (
      <span key={i} className="mx-6 sm:mx-10 inline-flex items-center gap-3 whitespace-nowrap">
        <item.icon size={22} strokeWidth={2.2} className="text-[#7DD3FC]" />
        <span className="font-heading text-lg sm:text-xl font-bold tracking-wide text-white/90">
          {item.label}
        </span>
        <span className="ml-6 sm:ml-10 h-1.5 w-1.5 rounded-full bg-[#FF6B6B]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden bg-[#0F2C59] py-5 border-y border-white/10"
  >
    <div className="marquee-track">
      <Row />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;
